module.exports = __webpack_public_path__ + "img/2.d332f30d.png";